// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vya-footer{background-color:black;padding:20px 25px}.vya-footer__bottom{display:flex;align-items:center;justify-content:center;flex-wrap:wrap;color:rgba(255,255,255,0.7)}.vya-footer__bottom-copyright{flex:1 1 50%;display:flex;justify-content:flex-start}.vya-footer__bottom-links{flex:1 1 50%;display:flex;justify-content:flex-end}@media (max-width: 768px){.vya-footer__bottom{flex-direction:column-reverse}.vya-footer__bottom-copyright,.vya-footer__bottom-links{flex:1 1 100%}}\n", ""]);
// Exports
module.exports = exports;
